const messages_en = require('./messages.json')
export default messages_en